import {
  ITimezoneOption,
  allTimezones as timezones,
  useTimezoneSelect,
} from 'react-timezone-select';

import { Select, SelectProps } from 'components/Select/Select';

export type TimezoneSelectProps = Pick<SelectProps<ITimezoneOption>, 'size'> & {
  value?: string;
  defaultValue?: string;
  onChange?: (value?: string) => void;
};

export function TimezoneSelect({
  value,
  defaultValue,
  onChange,
  ...props
}: TimezoneSelectProps) {
  const { options, parseTimezone } = useTimezoneSelect({
    timezones,
  });

  return (
    <Select<ITimezoneOption>
      {...props}
      value={value ? parseTimezone(value) : undefined}
      defaultValue={defaultValue ? parseTimezone(defaultValue) : undefined}
      options={options}
      onChange={(option) => onChange?.(option?.value)}
    />
  );
}
